import React from 'react'
import PropTypes from 'prop-types'
import { FormGroup, Radio, ControlLabel, HelpBlock, Alert } from 'react-bootstrap'
import questionTypes from '../questionTypes.json'

YesNoQuestion.propTypes = {
  questionId: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  answers: PropTypes.array.isRequired,
  onAnswer: PropTypes.func,
  readOnly: PropTypes.bool,
  showValidation: PropTypes.bool,
  validationState: PropTypes.string,
  help: PropTypes.string
}

export function YesNoQuestion({
  questionId,
  text,
  options,
  onAnswer,
  answers,
  readOnly,
  showValidation,
  validationState = null,
  help
}) {
  let newValidationStateToShow = showValidation ? validationState : null

  const selectedAnswersIds = answers.map(answer => answer.answerId)
  const { yesOption, noOption } = splitOptions(options);
  return (
    <FormGroup validationState={newValidationStateToShow}>
      <ControlLabel>{text}</ControlLabel>
      {!readOnly &&
      <div>
        <Radio key={'yes'}
          name={questionId}
          onClick={() => {
            onAnswer(questionId, questionTypes.yesNo, yesOption.answerId, "Yes")
          }}
          checked={selectedAnswersIds.indexOf(yesOption.answerId) > - 1}>
          {yesOption.text}
        </Radio>
        <Radio key={'no'}
          name={questionId}
          onClick={() => {
            onAnswer(questionId, questionTypes.yesNo, noOption.answerId, "No")
          }}
          checked={selectedAnswersIds.indexOf(noOption.answerId) > - 1}>
          {noOption.text}
        </Radio>
      </div>}
      {readOnly && options.map((option, index) => {
        if (selectedAnswersIds.indexOf(option.answerId) > - 1) {
          return <Radio key={index}
            name={questionId}
            disabled
            checked >
            {option.text}
          </Radio>
        }
        return ''
      })}
      {help && showValidation && <HelpBlock>
        <Alert bsStyle='danger'>
          {help}
        </Alert>
      </HelpBlock>}
    </FormGroup>)
}

function splitOptions(options) {
  let yesOption;
  let noOption;

  options.forEach(option => {
    if (option.yesNoValue === 'Yes') {
      yesOption = option;
    } else {
      noOption = option;
    }
  });

  return {
    yesOption,
    noOption
  }
}



// WEBPACK FOOTER //
// ./src/components/questions/YesNoQuestion/YesNoQuestion.js